import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { I18nModule } from "../i18n/i18n.module";
import { LoadingComponent } from "../ignite/loading/loading.component";
import { UtilsModule } from "../utils/utils.module";
import { AuthLayoutComponent } from './app-layouts/auth-layout.component';
import { EmptyLayoutComponent } from './app-layouts/empty-layout.component';
import { MainLayoutComponent } from './app-layouts/main-layout.component';
import { FooterComponent } from "./footer/footer.component";
import { HeaderModule } from "./header/header.module";
import { NavigationModule } from "./navigation/navigation.module";
import { RibbonComponent } from "./ribbon/ribbon.component";
import { RouteBreadcrumbsComponent } from './ribbon/route-breadcrumbs.component';
import { ShortcutComponent } from "./shortcut/shortcut.component";


@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    HeaderModule,
    NavigationModule,
    FormsModule,
    RouterModule,
    UtilsModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
  ],
  declarations: [
    FooterComponent,
    RibbonComponent,
    ShortcutComponent,
    MainLayoutComponent,
    EmptyLayoutComponent,
    AuthLayoutComponent,    
    LoadingComponent,
  ],
  exports: [
    HeaderModule,
    NavigationModule,
    FooterComponent,
    RibbonComponent,
    ShortcutComponent,
  ],
  providers: []
})
export class SmartadminLayoutModule {

}
